module.exports = __webpack_public_path__ + "img/credit-card.a8230d97.svg";